// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__35svt","inner":"Footer_inner__1_BYY","nextIcon":"Footer_nextIcon__1JvHz","innerLeft":"Footer_innerLeft__1VtCi"};